const getKPIsImpactedByMetrics = (kpiMetrics, kpis) => {
  return kpis?.filter((kpi) =>
    kpi?.definition?.metricMappings?.some((metric) =>
      kpiMetrics?.includes(metric)
    )
  );
};

export default getKPIsImpactedByMetrics;
